export function initials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "—";
  const first = parts[0]?.[0] || "";
  const last = parts[parts.length - 1]?.[0] || "";
  return (first + last).toUpperCase();
}

export function formatDate(s) {
  if (!s) return "—";
  const d = s.length <= 10 ? new Date(s + "T00:00:00") : new Date(s);
  return isNaN(d.getTime()) ? s : d.toLocaleDateString();
}

export function titleCase(s) {
  if (!s) return "—";
  return String(s)
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
